import styles from "./ChatAttachmentModal.styles.scss";
import Button from "../Button/Button";
import {Body, Subtitle} from "../typography";
import {Column, Expand, Row} from "../Layout/Layout";
import Margin from "../Margin/Margin";
import {useState} from "preact/hooks";
import Icon from "../Icon/Icon";
import ProgressBar from "../ProgressBar/ProgressBar";
import Toast from "../Toast/Toast";

const ChatAttachmentModal = ({isUploading, onDialog, onSelectFile, onDrop, onDragOver, uploadProgress, uploadMax, fileName, onClose, inputRef, error}) => {
  const [counter, setCounter] = useState(0);
  const isDragging = counter > 0;

  const onDragEnter = () => {
    setCounter(counter + 1);
  };

  const onDragLeave = () => {
    setCounter(counter - 1);
  };

  return <div className={styles.container}>
    <input type="file" ref={inputRef} style={{display: "none"}} onChange={onSelectFile} />
    <Row>
      <Subtitle size="subtitle1" weight={600}>{fileName ? "Anexando arquivo..." : "Anexar arquivo"}</Subtitle>
      <Expand />
      {!isUploading && <Icon name="close" onClick={onClose} color="#9E9E9E" />}
    </Row>
    {!isUploading && <Row flex className={[styles.dropzone, isDragging && styles.dragging].join(" ")} onDrop={onDrop}
          onDragOver={onDragOver} onDragEnter={onDragEnter} onDragLeave={onDragLeave}>
      <Column flex horizontalCenter verticalCenter style={{maxWidth: '100%'}}>
        <Margin top={16}/>
        <Button title="Procurar" onClick={onDialog}/>
        <Margin top={4}/>
        <Body className={styles.cursorDefault} color="#9E9E9E" weight={600}>ou arraste um arquivo até aqui</Body>
      </Column>
    </Row>}
    {isUploading && <Row flex className={[styles.dropzone, styles.dropzoneDisabled]}>
      <Column flex horizontalCenter verticalCenter style={{maxWidth: '100%'}}>
        <Row>
          <Icon name="cloud_upload" color="#9E9E9E" />
          <Margin left={4} />
          <Body className={styles.cursorDefault} color="#9E9E9E">{fileName}</Body>
        </Row>
        <Margin top={4} />
        <ProgressBar max={uploadMax} value={uploadProgress} />
      </Column>
    </Row>}
    {error && <Margin top={8}><Toast message={error} /></Margin>}
  </div>
};

export default ChatAttachmentModal;



// WEBPACK FOOTER //
// ./components/ChatAttachmentModal/ChatAttachmentModal.js